import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CTAButton from '../../../CTAButton';
import RadioButton from '../../../ComponentLibrary/input-elements/oc-radio-button';
import BackButton from '../../shared/BackButton';
import { incrementStep, setFormData, backToPropertyAddress } from '../redux/action';

const CurrentPropertyOwner = () => {
  const { formData, metadata, isFetching } = useSelector(state => state);
  const dispatch = useDispatch();

  const enableBtn = () => {
    if (formData.correctPropertyOwner === 'Yes' || formData.correctPropertyOwner === 'No') {
      return false;
    }

    return true;
  };

  const { warrantyDetails } = metadata;

  return (
    <>
      <BackButton
        analytics={{
          'data-track': 'form-back',
          'data-track-form-name': 'Submit Claim',
          'data-track-form-step': 'step 2 - do you own the property',
        }}
        onClick={() =>
          dispatch(
            setFormData({
              showCurrentPropertyOwner: false,
              showNoAvailableWarray: false,
            })
          )
        }
        backText="Verification"
      />
      <p className="p14">Great! Let's make sure we have the right person.</p>
      <h4>Our records indicate that current property owner is:</h4>
      {isFetching ? (
        <p>...Loading</p>
      ) : (
        <p>
          {warrantyDetails?.property_information?.first_name} {warrantyDetails?.property_information?.last_name}
        </p>
      )}
      <h4>Is this correct?</h4>
      <div
        onChange={event => {
          dispatch(
            setFormData({
              ...formData,
              correctPropertyOwner: event.target.value,
            })
          );
        }}
        className="twoFields mt10 mb10"
      >
        <div className="radioContainer">
          <RadioButton name="correctOwnerName" value="Yes">
            Yes
          </RadioButton>
        </div>
        <div className="radioContainer">
          <RadioButton name="correctOwnerName" value="No">
            No
          </RadioButton>
        </div>
      </div>

      <CTAButton
        onClick={
          formData.correctPropertyOwner === 'Yes'
            ? () => dispatch(incrementStep())
            : () =>
                dispatch(
                  setFormData({
                    showCurrentPropertyOwner: false,
                    showRepAssistance: true,
                  })
                )
        }
        data-track="form-advance"
        data-track-form-name="Submit Claim"
        data-track-form-step="step 2 - do you own this property"
        element="button"
        text="Next"
        type="submit"
        disabled={enableBtn()}
      />
    </>
  );
};

export default CurrentPropertyOwner;
